import { render } from "./StafetDeltagPaaHoldStepOne.vue?vue&type=template&id=4c4c0e6e"
import script from "./StafetDeltagPaaHoldStepOne.vue?vue&type=script&lang=js"
export * from "./StafetDeltagPaaHoldStepOne.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__